import { runDemo } from "../shared/demoRunner";
import { createLinesScene } from "./scene";

runDemo({
    createScene: createLinesScene,
});
